import { useState } from "react";
import styles from "./sideNavItem.module.scss";

import { attribute } from "../../../types/attributeType";

import MinusSvg from "../../common/ui/MinusSvg";
import PlusSvg from "../../common/ui/PlusSvg";
import SearchInputBox from "../SearchInputBox";
import SideNavCheckboxArea from "./SideNavCheckboxArea";

type Props = {
  label: string;
  attributes: Array<attribute>;
  onChangeCheckbox: (label: string, attr: attribute) => void;
  fmtAttribute: (attribute: string) => string;
};

const SideNavItem = ({
  label,
  attributes,
  onChangeCheckbox,
  fmtAttribute,
}: Props) => {
  // サブメニュー表示の状態
  const [isShow, setIsShow] = useState(false);

  // サブメニュー表示
  const toggle = () => {
    setIsShow(!isShow);
  };

  // 表示するattributes
  const [attrList, setAttrList] = useState<Array<attribute>>(attributes);

  // sortText
  const [sortText, setSortText] = useState("");

  const onChangeSortText = (
    event: React.ChangeEvent<HTMLInputElement>
  ): void => {
    setSortText(event.target.value);
    searchAttr(event.target.value);
  };

  const searchAttr = (value: string) => {
    if (value === "") {
      setAttrList(attributes);
      return;
    }

    const searchKeywords = value
      .trim()
      .toLowerCase()
      .match(/[^\s]+/g);

    //入力されたキーワードが空白のみの場合
    if (searchKeywords === null) {
      setAttrList(attributes);
      return;
    }

    // 検索文字列でフィルタリングする
    const filteredList = attributes.filter((attr: attribute) =>
      searchKeywords.every(
        (kw) => attr.content.toLowerCase().indexOf(kw) !== -1
      )
    );
    setAttrList(filteredList);
    return;
  };

  return (
    <div>
      <button className={styles["item-button"]} type="button" onClick={toggle}>
        <p>{fmtAttribute(label)}</p>
        <div className="w-[20px] h-[20px] flex justify-center items-center">
          {isShow ? <MinusSvg /> : <PlusSvg />}
        </div>
      </button>
      <div
        style={{ display: isShow ? "block" : "none" }}
        className={styles["sub-area"]}
      >
        <SearchInputBox
          value={sortText}
          onChange={onChangeSortText}
          placeholder="search"
        />
        <div className={styles["search-check-wrap"]}>
          <div className={styles["search-check-inner"]}>
            {attrList.map((attr, index) => (
              <SideNavCheckboxArea
                key={index}
                text={attr.content || "None"}
                onChange={() => onChangeCheckbox(label, attr)}
                checked={attr.checked}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SideNavItem;
